module.exports = __webpack_public_path__ + "static/7-9553035587e41bcef4e67b6951196507.jpg";